<div id = "page">
  <div id = "criteria">
    <app-job-search-criteria>

    </app-job-search-criteria>
  </div>
  <div id = "results">
    <!-- <h3>Providers trouvés ({{ (previewTotalCount$ | async)}}) </h3> -->
    <h3>Activités trouvées ({{jobResults.length}}) </h3>

    <app-jobs
      [objectSource]="objectSource"
      [carId]="carId"
      [enableNew]="false"
      [potentialProviders]="(currentDealer$ | async)!.favoriteProviderIds">
    </app-jobs>

    <div class = "paginator">
      <div class = "page-selectors">

        <mat-label class="icon-text">Items par page</mat-label>
        <mat-select class="page-size" required name = "pageSize" [(ngModel)]="pageSize" (selectionChange)="updatePageSize()">
          @for (size of pageSizeOptions; track size; let i = $index) {
            <mat-option [value]="size" >{{size}}</mat-option>
          }
        </mat-select>

      </div>
      <div class= "page-numbers">
        <button [disabled]="jobCriteria.pageNumber < 1" mat-button (click)="loadPreviousPage();$event.stopPropagation()" class="pic-arrow-left"> <mat-icon>arrow_back_ios</mat-icon>  <span class="icon-text">Précédente</span></button>

        @for (pgNumber of pageNumbers; track pgNumber) {
          <button [disabled]="jobCriteria.pageNumber === pgNumber" mat-button (click)="loadPage(pgNumber);$event.stopPropagation()" > {{ pgNumber+1 }} </button>
        }

        <button [disabled]="jobCriteria.pageNumber >= totalItems/jobCriteria.pageSize - 1" mat-button (click)="loadNextPage();$event.stopPropagation()" class="pic-arrow-right"> <span class="icon-text">Suivante</span> <mat-icon>arrow_forward_ios</mat-icon></button>
      </div>
    </div>
  </div>
</div>



